import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {  FiSearch, FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { IoSettings, IoColorPalette, IoResize } from 'react-icons/io5'
import { MdInventory, MdCategory, MdDelete, MdEdit, MdImage, MdCloudUpload } from 'react-icons/md'



import { toast } from 'react-toastify';
import { AnimatePresence, motion } from 'framer-motion'
import AIContentGenerator from './AIContentGenerator';
import VariationForm from './VariationForm';
import { useSelector } from 'react-redux';

function AddProduct() {
  const [editId, setEditId] = useState('');
  const [imagePreviewEdit, setImagePreviewEdit] = useState('');
  const [changeOver, setChangeOver] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [colorId, setColorId] = useState([]);
  const [color, setColor] = useState([]);
  const [size, setSize] = useState([]);
  const [sizeId, setSizeId] = useState([]);
  const [isMultiImages, setIsMultiImages] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState('');
  const [serialStart, setSerialStart] = useState('');
  const [btnClick, setBtnClick] = useState(false);
  const weburl = useSelector(state => state.constants.weburl);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    axios.get(`/api/view/products?page=${currentPage}&search=${searchQuery}`).then(response => {
      setItemsPerPage(response.data.products.per_page);
      setProducts(response.data.products.data);
      setTotalPages(response.data.products.last_page);
    })
  }, [currentPage, searchQuery, btnClick]);

  useEffect(() => {
    setSerialStart((currentPage - 1) * itemsPerPage + 1);
  }, [currentPage, itemsPerPage]);

  const handleProductEdit = (e, id) => {
    e.preventDefault();
    setEditId(id);
    axios.get(`api/edit/onlinestore/product/${id}`).then(res => {
      setInputData({
        name: res.data.product.name === null ? '' : res.data.product.name,
        image: res.data.product.image === null ? '' : res.data.product.image,
        description: res.data.product.description === null ? '' : res.data.product.description,
        shipping: res.data.product.shipping === '0' ? '0' : res.data.product.shipping,
        hot: (res.data.product.hot === 'false' || res.data.product.hot === '' || res.data.product.hot === null) ? false : true,
        alias: res.data.product.alias === null ? '' : res.data.product.alias,
        unitcostprice: res.data.product.unitcostprice === null ? '' : res.data.product.unitcostprice,
        unitsaleprice: res.data.product.unitsaleprice === null ? '' : res.data.product.unitsaleprice,
        unitretailprice: res.data.product.unitretailprice === null ? '' : res.data.product.unitretailprice,
        unitwholesaleprice: res.data.product.unitwholesaleprice === null ? '' : res.data.product.unitwholesaleprice,
        qty: res.data.product.qty === null ? '' : res.data.product.qty
      })
      setImagePreviewEdit(res.data.product.image);
      const ids = res.data.categories.map(obj => obj.id);
      setColorId(res.data.colors.map(obj => obj.id));
      setCategoryId(ids);
    }).catch(error => {
      alert(error);
    })
  }

  const [inputData, setInputData] = useState({
    image: '',
    name: '',
    qty: '',
    alias: '',
    unitwholesaleprice: '',
    unitretailprice: '',
    unitcostprice: '',
    unitsaleprice: '',
    shipping: '0',
    hot: false,
  })

  const handleImage = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) {
      toast.error('No file selected!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setInputData({ ...inputData, image: file });
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  const handleSubmitProduct = (e) => {
    e.preventDefault();
    setBtnClick(true);
    const formData = new FormData();
    formData.append('categoryIds', JSON.stringify(categoryId));
    formData.append('id', editId);
    for (const key in inputData) {
      formData.append(key, inputData[key]);
    }
    if (inputData.name === '' || inputData.image === '' || inputData.alias === '' || categoryId.length < 1) {
      toast.error('Product name, image and SKU is required or select one category!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnClick(false);
      return false;
    }
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.post(`/api/post/onlinestore/product`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        toast.success('Product Saved!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setBtnClick(false);
        setImagePreview('');
      });
    });
  }

  const megaManu = (categories, stire, handleSetCategoryId, categoryId) => {
    return (
      <motion.div className={`flex ${stire} justify-around `}>
        {categories.length === 0 ? (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1.5, loop: Infinity, ease: "linear" }}
            style={{
              width: 50,
              height: 50,
              border: '2px solid #ccc',
              borderRadius: '50%',
              borderTopColor: '#007bff',
              position: 'relative',
              margin: '0 auto',
            }}
          />
        ) : (
          <div>
            {categories.map((item, index) => (
              <div key={index}>
                <div className="pt-2 pl-2">
                  <div className='flex pl-2 items-center'>
                    <input type='checkbox' checked={categoryId.includes(item.id)} onChange={(e) => handleSetCategoryId(item.id)} className="w-4 h-4 text-blue-600 rounded" />
                    <h1 className='ml-3 text-sm font-medium text-gray-700'>{item.name}</h1>
                  </div>
                  {item.children.length > 0 && (
                    <div className="text-sm text-gray-400 ml-6">
                      {megaManu(item.children, 'flex-col', handleSetCategoryId, categoryId)}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </motion.div>
    )
  }

  const handleInput = (e) => {
    e.preventDefault();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  }

  const handleCheckedHot = (e) => {
    setInputData({ ...inputData, hot: e.target.checked ? true : false });
  }

  useEffect(() => {
    axios.get('/api/tree/categorylist').then(res => {
      setCategories(res.data.categories);
      setColor(res.data.colors);
      setSize(res.data.sizes);
    })
  }, [])

  const handleEditorChange = (e) => {
    setInputData({
      ...inputData,
      description: e.target.value,
    });
  };

  const handleAIEditorChange = (content) => {
    setInputData({
      ...inputData,
      description: content,
    });
  }
const sethandleChangeOver=(e,id)=>{
  e.preventDefault();
  setChangeOver(id)
}
  const handleSetCategoryId = (id) => {
    const index = categoryId.indexOf(id);
    if (index !== -1) {
      const updatedCategoryIds = categoryId.filter(category => category !== id);
      setCategoryId(updatedCategoryIds);
    } else {
      setCategoryId([...categoryId, id]);
    }
  }

  const handleSetColorId = (id) => {
    const index = colorId.indexOf(id);
    if (index !== -1) {
      const updatedColorIds = colorId.filter(color => color !== id);
      setColorId(updatedColorIds);
    } else {
      setColorId([...colorId, id]);
    }
  }

  const handleSetSizeId = (id) => {
    const index = sizeId.indexOf(id);
    if (index !== -1) {
      const updatedSizeIds = sizeId.filter(size => size !== id);
      setSizeId(updatedSizeIds);
    } else {
      setSizeId([...sizeId, id]);
    }
  }

  const handleIsMultiImages = (e) => {
    e.preventDefault();
    setIsMultiImages(!isMultiImages);
  }

  const menuItems = [
    { id: 0, name: 'General', icon: <IoSettings size={18} />, color: 'text-gray-600' },
    { id: 1, name: 'Inventory', icon: <MdInventory size={18} />, color: 'text-blue-600' },
    { id: 2, name: 'Colors', icon: <IoColorPalette size={18} />, color: 'text-purple-600' },
    { id: 3, name: 'Sizes', icon: <IoResize size={18} />, color: 'text-green-600' },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className='relative bg-gray-50 min-h-screen'
    >
      <form encType="multipart/form-data" method='post' onSubmit={(e) => handleSubmitProduct(e)}>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6'>
          <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
            
            {/* Main Content Area - 2/3 width on desktop */}
            <div className='lg:col-span-2 space-y-6'>
              {/* Header */}
              <div className='bg-white rounded-xl shadow-sm p-6'>
                <h1 className='text-2xl font-bold text-gray-800 mb-4'>Add New Product</h1>
                <input
                  type='text'
                  name='name'
                  value={inputData.name}
                  onChange={(e) => handleInput(e)}
                  className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all'
                  placeholder='Enter product title...'
                />
              </div>

              {/* AI Content Generator */}
              <div className='bg-white rounded-xl shadow-sm p-6'>
                <AIContentGenerator handleAIEditorChange={handleAIEditorChange} />
              </div>

              {/* Description */}
              <div className='bg-white rounded-xl shadow-sm p-6'>
                <label className='block text-sm font-medium text-gray-700 mb-2'>Description</label>
                <textarea
                  name='description'
                  rows={8}
                  className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all'
                  onChange={(e) => handleEditorChange(e)}
                  value={inputData.description}
                  style={{ resize: 'none', overflow: 'hidden' }}
                  onInput={(e) => {
                    e.target.style.height = 'auto';
                    e.target.style.height = e.target.scrollHeight + 'px';
                  }}
                />
              </div>

              {/* Tabs Section */}
              <div className='bg-white rounded-xl shadow-sm overflow-hidden'>
                <div className='border-b border-gray-200'>
                  <div className='flex gap-1 p-2'>
                    {menuItems.map((item) => (
                      <button
                        key={item.id}
                        onClick={(e) => sethandleChangeOver(e,item.id)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                          changeOver === item.id
                            ? 'bg-blue-50 text-blue-600 shadow-sm'
                            : 'text-gray-600 hover:bg-gray-50'
                        }`}
                      >
                        {item.icon}
                        <span className='font-medium'>{item.name}</span>
                      </button>
                    ))}
                  </div>
                </div>

                <div className='p-6'>
                  {changeOver === 0 && (
                    <div className='space-y-4'>
                      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>SKU</label>
                          <input
                            name='alias'
                            value={inputData.alias}
                            onChange={(e) => handleInput(e)}
                            className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                            placeholder='SKU Number'
                          />
                        </div>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>Shipping</label>
                          <select
                            name='shipping'
                            value={inputData.shipping}
                            onChange={(e) => handleInput(e)}
                            className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                          >
                            <option value={0}>No Shipping</option>
                            <option value={1}>Free Shipping</option>
                          </select>
                        </div>
                      </div>
                      <div className='flex items-center gap-3'>
                        <label className='flex items-center gap-2 cursor-pointer'>
                          <input
                            type='checkbox'
                            checked={inputData.hot}
                            onChange={handleCheckedHot}
                            className='w-4 h-4 text-blue-600 rounded'
                          />
                          <span className='text-sm font-medium text-gray-700'>Mark as Hot Deal</span>
                        </label>
                      </div>
                    </div>
                  )}

                  {changeOver === 1 && (
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                      <div>
                        <label className='block text-sm font-medium text-gray-700 mb-1'>Cost Price</label>
                        <input
                          name='unitcostprice'
                          value={inputData.unitcostprice}
                          onChange={(e) => handleInput(e)}
                          className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                          placeholder='$0.00'
                        />
                      </div>
                      <div>
                        <label className='block text-sm font-medium text-gray-700 mb-1'>Retail Price</label>
                        <input
                          name='unitretailprice'
                          value={inputData.unitretailprice}
                          onChange={(e) => handleInput(e)}
                          className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                          placeholder='$0.00'
                        />
                      </div>
                      <div>
                        <label className='block text-sm font-medium text-gray-700 mb-1'>Sale Price</label>
                        <input
                          name='unitsaleprice'
                          value={inputData.unitsaleprice}
                          onChange={(e) => handleInput(e)}
                          className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                          placeholder='$0.00'
                        />
                      </div>
                      <div>
                        <label className='block text-sm font-medium text-gray-700 mb-1'>Wholesale Price</label>
                        <input
                          name='unitwholesaleprice'
                          value={inputData.unitwholesaleprice}
                          onChange={(e) => handleInput(e)}
                          className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                          placeholder='$0.00'
                        />
                      </div>
                      <div>
                        <label className='block text-sm font-medium text-gray-700 mb-1'>Product Quantity</label>
                        <input
                          name='qty'
                          value={inputData.qty}
                          onChange={(e) => handleInput(e)}
                          className='w-full px-3 py-2 border border-gray-300 rounded-lg'
                          placeholder='0'
                        />
                      </div>
                    </div>
                  )}

                  {changeOver === 2 && (
                    <div className='flex flex-wrap gap-3'>
                      {color.map((item, index) => (
                        <label key={index} className='flex items-center gap-2 cursor-pointer'>
                          <input
                            type='checkbox'
                            checked={colorId.includes(item.id)}
                            onChange={() => handleSetColorId(item.id)}
                            className='w-4 h-4 text-blue-600 rounded'
                          />
                          <span className='text-sm text-gray-700'>{item.name}</span>
                        </label>
                      ))}
                    </div>
                  )}

                  {changeOver === 3 && (
                    <div className='flex flex-wrap gap-3'>
                      {size.map((item, index) => (
                        <label key={index} className='flex items-center gap-2 cursor-pointer'>
                          <input
                            type='checkbox'
                            checked={sizeId.includes(item.id)}
                            onChange={() => handleSetSizeId(item.id)}
                            className='w-4 h-4 text-blue-600 rounded'
                          />
                          <span className='text-sm text-gray-700'>{item.name}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Products Table */}
              <div className='bg-white rounded-xl shadow-sm overflow-hidden'>
                <div className='p-4 border-b border-gray-200'>
                  <div className='flex flex-col sm:flex-row justify-between gap-4'>
                    <h2 className='text-lg font-semibold text-gray-800'>All Products</h2>
                    <div className='relative'>
                      <FiSearch className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400' />
                      <input
                        type="text"
                        placeholder='Search products...'
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className='pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500'
                      />
                    </div>
                  </div>
                </div>

                <div className='overflow-x-auto'>
                  <div className='max-h-[400px] overflow-y-auto'>
                    <table className='min-w-full divide-y divide-gray-200'>
                      <thead className='bg-gray-50 sticky top-0'>
                        <tr>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>#</th>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>Name</th>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>Image</th>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>Category</th>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>SKU</th>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>Hot</th>
                          <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase'>Actions</th>
                        </tr>
                      </thead>
                      <tbody className='bg-white divide-y divide-gray-200'>
                        {products.map((item, index) => (
                          <tr key={index} className='hover:bg-gray-50 transition-colors'>
                            <td className='px-6 py-4 text-sm text-gray-500'>{serialStart + index}</td>
                            <td className='px-6 py-4 text-sm text-gray-900'>{item.name}</td>
                            <td className='px-6 py-4'>
                              <img alt='product' src={`${weburl}/${item.image}`} className='h-12 w-12 object-cover rounded-lg' />
                            </td>
                            <td className='px-6 py-4 text-sm text-gray-500'>{item.categoryname}</td>
                            <td className='px-6 py-4 text-sm text-gray-500'>{item.alias}</td>
                            <td className='px-6 py-4'>
                              {item.hot === 'true' ? (
                                <span className='px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded-full'>Hot</span>
                              ) : '-'}
                            </td>
                            <td className='px-6 py-4'>
                              <div className='flex gap-2'>
                                <button onClick={(e) => handleProductEdit(e, item.id)} className='p-1 text-blue-600 hover:bg-blue-50 rounded transition-all'>
                                  <MdEdit size={18} />
                                </button>
                                <button className='p-1 text-red-600 hover:bg-red-50 rounded transition-all'>
                                  <MdDelete size={18} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination */}
                <div className='px-6 py-4 border-t border-gray-200 flex justify-between items-center'>
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((page) => page - 1)}
                    className='flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
                  >
                    <FiChevronLeft /> Previous
                  </button>
                  <span className='text-sm text-gray-600'>Page {currentPage} of {totalPages}</span>
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((page) => page + 1)}
                    className='flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
                  >
                    Next <FiChevronRight />
                  </button>
                </div>
              </div>
            </div>

            {/* Sidebar - 1/3 width on desktop */}
            <div className='space-y-6'>
              {/* Publish Card */}
              <div className='bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl shadow-lg p-6'>
                <div className='flex items-center justify-between mb-4'>
                  <h3 className='text-white font-semibold'>Publish Product</h3>
                 
                </div>
                <button className='w-full bg-white text-blue-600 font-semibold py-3 rounded-lg hover:bg-gray-100 transition-all transform hover:scale-[1.02]'>
                  {btnClick === true ? 'Saving...' : 'Publish Product'}
                </button>
              </div>

              {/* Categories Card */}
              <div className='bg-white rounded-xl shadow-sm overflow-hidden'>
                <div className='p-4 border-b border-gray-200'>
                  <div className='flex items-center gap-2'>
                    <MdCategory className='text-gray-600' />
                    <h3 className='font-semibold text-gray-800'>Categories</h3>
                  </div>
                </div>
                <div className='p-4 max-h-80 overflow-y-auto'>
                  {megaManu(categories, 'flex-col', handleSetCategoryId, categoryId)}
                </div>
              </div>

              {/* Image Upload Card */}
              <div className='bg-white rounded-xl shadow-sm overflow-hidden'>
                <div className='p-4 border-b border-gray-200'>
                  <div className='flex items-center gap-2'>
                    <MdImage className='text-gray-600' />
                    <h3 className='font-semibold text-gray-800'>Product Image</h3>
                  </div>
                </div>
                <div className='p-6'>
                  <div className='border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-500 transition-colors'>
                    {(imagePreviewEdit || imagePreview) && (
                      <div className='mb-4'>
                        <img
                          alt='Preview'
                          src={imagePreviewEdit ? `${weburl}${imagePreviewEdit}` : imagePreview}
                          className='h-32 w-32 object-cover rounded-lg mx-auto'
                        />
                      </div>
                    )}
                    <label className='cursor-pointer'>
                      <div className='flex flex-col items-center'>
                        <MdCloudUpload className='text-gray-400 text-4xl mb-2' />
                        <p className='text-sm text-gray-600'>Click to upload product image</p>
                        <p className='text-xs text-gray-400 mt-1'>PNG, JPG, GIF up to 2MB</p>
                      </div>
                      <input
                        type='file'
                        onChange={handleImage}
                        name='image'
                        className='hidden'
                        accept='image/*'
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Add More Images Button */}
              {editId && (
                <button
                  onClick={handleIsMultiImages}
                  className='w-full py-3 text-blue-600 font-medium border border-blue-600 rounded-lg hover:bg-blue-50 transition-all'
                >
                  + Add More Images
                </button>
              )}
            </div>
          </div>
        </div>
      </form>

      <AnimatePresence>
        {isMultiImages && (
          <VariationForm
            productId={editId}
            weburl={weburl}
            handleIsMultiImages={handleIsMultiImages}
            color={color}
            size={size}
          />
        )}
      </AnimatePresence>
    </motion.div>
  )
}

export default AddProduct